export default "__VITE_ASSET__CQnDpc_7__"